module.exports = __webpack_public_path__ + "img/learnMore1-1.4fe93e31.jpg";